module.exports = __webpack_public_path__ + "img/Bottone-Dipendenti.5fe99678.jpg";